import FormJaivana from 'dashboard_jaivana_v1';

/**
 * @author: Actualizacion -- Juan David Nieto
 * @version: 2,0
 * @description: funciones adicionales al formulario Recepcion Ajustes, Actualizacion de servicios
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */



class CustomAjustesRecepcion extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                   = this.initForm.bind(this);
        this.gridOptionsAjustes                     =   Object.assign({},this.gridOptions);
        this.successTablaItemFichas     = this.successTablaItemFichas.bind(this);
        this.setButtonDelete            = this.setButtonDelete.bind(this);
        this.uploadTable                = this.uploadTable.bind(this);
        this.successUploadTable         = this.successUploadTable.bind(this);
        this.tamanoDatos                = 0;
        this.initModaloperario          = this.initModaloperario.bind(this);
        this.setOperario                = this.setOperario.bind(this);
        this.setButtonOperario          = this.setButtonOperario.bind(this);
        this.successSelect              = this.successSelect.bind(this);
        this.grabarItem                 = this.grabarItem.bind(this);
        this.grabarTodo                 = this.grabarTodo.bind(this);
        this.successGrabarItem          = this.successGrabarItem.bind(this);
        this.formato                    = this.formato.bind(this);
        this.formato2                   = this.formato2.bind(this);
        this.grabarOperario             = this.grabarOperario.bind(this);
        this.successGrabarOperario      = this.successGrabarOperario.bind(this);
        this.setSelectRec               = this.setSelectRec.bind(this);
        this.devolverRecepcion          = this.devolverRecepcion.bind(this);
        this.selectOperario             = [];
        this.successSelectOperario      = this.successSelectOperario.bind(this);
        this.recuperarItemsFichas       = this.recuperarItemsFichas.bind(this);
        this.recuperarOperarios         = this.recuperarOperarios.bind(this);
        this.datosFicha                 = this.datosFicha.bind(this)
        this.successDatosFichas         = this.successDatosFichas.bind(this);
        this.verFormula                 = this.verFormula.bind(this);
        this.successVerFormula          = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula      = Object.assign({}, this.gridOptions);
        this.successClose               = this.successClose.bind(this);
    }

    initForm() {
        console.log('CustomAjustesRecepcion @version: 1.01.0054 @author: Juan David Nieto; @updateBy: Sebastian Rios Echverri');
        this.datosFicha()
        this.recuperarOperarios();
        this.getField('btnTerminarAjusteRec').setClick(this.grabarTodo);
        this.getField('btnDevolver').setClick(this.devolverRecepcion);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    datosFicha(){
        let datos = {
            datos:{
                value:this.props.data.id_ficha
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFichas,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
            /*this.generalFormat.nombre_accion = 'servicio_traer_datos_de_ficha_ajustes_recepcion';
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'GET',
                    body:body,
                    success: this.successDatosFichas, 
                    error:this.error_,
                    general: this.generalFormat,
                });*/
    }
    successDatosFichas(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('listaAjesteRecepcion').setVisible(true);
            this.getField('listaAjesteRecepcion').setItemsFichas(data.model);
        }else{
            this.getField('listaAjesteRecepcion').setVisible(false);
        }
    }
    recuperarItemsFichas(){
        let datos = {
            datos:{
                value:this.props.data.id_ficha
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
            /*this.generalFormat.nombre_accion = 'servicio_traer_items_ajustes_recepcion';
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'GET',
                    body:body,
                    success: this.successTablaItemFichas, 
                    error:this.error_,
                    general: this.generalFormat,
                });*/
    }
    recuperarOperarios(){
        let datos = {
            datos:{}
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-operarios', operacion: 'todos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successSelectOperario,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
            /*this.generalFormat.nombre_accion = '268_Retorna_todos_los_produccion_operarios';
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'GET',
                    body:body,
                    success: this.successSelectOperario, 
                    error:this.error_,
                    general: this.generalFormat,
                }); */ 
    }

    devolverRecepcion(){
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('btnDevolver').setDisabled(true);
        let datos = {
            datos:{
                id_formulario: this.formId,
                produccion_fichas_id: this.getField('produccion_fichas_id').getValue(),
                proceso_id: this.getField('proceso_id').getValue(),
                actividad_configuracion_id: this.getField('actividad_configuracion_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue() 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'devolver', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successClose,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'produccion_ajuste_recepcion-devolver';
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'POST',
                body:body,
                success: this.successCloseEstage, 
                error:this.error_,
                general: this.generalFormat,
            }); */ 

    }

    successClose(data){
        this.getField('btnDevolver').setDisabled(false);
        this.getField('btnTerminarAjusteRec').setDisabled(false);
        this.successCloseEstage(data);
    }

    successSelectOperario(data){       
        this.recuperarItemsFichas();
        if(data.estado_p === 200)
            this.selectOperario = data.model;
    }
    successSelect(){
        let opcionN = document.createElement('option');
        opcionN.setAttribute('value',' ');
        opcionN.textContent = 'Ninguno';
        let datos = [opcionN];
        this.selectOperario.map((item) =>{
            let opcion = document.createElement('option');
            opcion.setAttribute('value',parseInt(item.id));
            opcion.textContent = item.nombre;
            datos.push(opcion);
            return null;
        })
        return datos;
    }
    
    
    formato(props){
        return ("".formatoPrecio(props.data.cantidad_galones));
    }

    formato2(props){
        return ("".formatoPrecio(props.data.cantidad_kilos));
    }

    successTablaItemFichas(data){ 
        if(data.estado_p === 200){
            this.tamanoDatos = data.model.length;
            let configCell = new Map();
            configCell.set(0,{cellRenderer:this.setButtonDelete ,field: 'accion',width:150 });
            configCell.set(1,{cellRenderer:this.setButtonOperario ,field: 'operario',width:280});
            configCell.set(3,{field: 'lote',width:100 });  
            configCell.set('nombre_unidad',{field: 'nombre_unidad',width:130 });         
            configCell.set('cantidad_galones',{cellRenderer:this.formato,  cellStyle: { textAlign: "right" },field: 'cantidad_galones',width:170 });   
            configCell.set('cantidad_kilos',{cellRenderer:this.formato2,  cellStyle: { textAlign: "right" },field: 'cantidad_kilos',width:150 });           
        
            this.gridOptionsAjustes['rowData'] = data.model;
            this.getField('tablaAjusteRecepcion').initData(this.gridOptionsAjustes,configCell);
        }else{
            this.tamanoDatos = 0;
            this.getField('tablaAjusteRecepcion').toggle(false);
        }
    }

    setSelectRec(){
        let data = {
            values:[]
        };
        this.selectOperario.map((item) =>{
            data.values.push(item.nombre+"-"+item.id);
            return null;
        })
        return data;
    }

    setButtonDelete(props){
        let id = props.data.id;
        let operario = props.data.nombre_operario;
        let button = document.createElement("input"); 
        button.onclick = ()=>this.grabarItem(id,operario);
        button.setAttribute("id",'button_delete_'+id);
        button.setAttribute("class","buttonStyle");//,"width: 100%; height: 100%;background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        button.setAttribute("type","button");
        button.setAttribute("value","Recibir");
        return this.createElementJaivana(button);
    }

    setButtonOperario(props){
        let nombreOperario = props.data.nombre_operario;
        let div = document.createElement("div");
        let select = document.createElement("select");
        select.setAttribute('class', 'selectStyle1');
        select.onchange = (event) => this.grabarOperario(props.data.id,event.target.value);
        select.setAttribute('id', 'mySelectOperario_');
        let opciones = this.successSelect();
        this.valor_idOpe = 0;        
        opciones.map((item) => {  
            select.appendChild(item);
            if (item.textContent === nombreOperario)
                this.valor_idOpe = parseInt(item.value);
            return null;
        });
        if(this.valor_idOpe > 0)
            select.value = this.valor_idOpe;
        div.appendChild(select)
        return this.createElementJaivana(div);
    }

    setOperario(id){
        this.operario_id = id;
        this.getField('modalOperarioRecepcion').handleClickOpen(this.initModaloperario.bind(this));
    }

    initModaloperario(){
        this.getField('btnGuardarOperarioRecepccion').setClick(this.grabarOperario);
    }
    grabarOperario(idCell,id){
       let datos = {
            datos:{
                id_formulario: this.formId,
                id: parseInt(idCell),
                produccion_operario_id:parseInt(id),
                actividad_id:this.props.data.actividad_id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'operario', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successGrabarOperario,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_asignar_operario_ajustes_recepcion';
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'PUT',
                body:body,
                success: this.successGrabarOperario, 
                error:this.error_,
                general: this.generalFormat,
            });*/  
    }

    successGrabarOperario(data){
        if(data.estado_p === 200){
            this.uploadTable();
            this.getField('modalOperarioRecepcion').handleClose();
            this.recuperarOperarios();
        }
    }

    uploadTable(){ 
        let datos = {
            datos:{
                value:this.props.data.id_ficha
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            showMessage :false,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = 'servicio_traer_items_ajustes_recepcion';
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success: this.successUploadTable, 
                error:this.error_,
                general: this.generalFormat,
            }); */ 
    }
    successUploadTable(data){
        if(data.estado_p === 200){                          
        this.gridOptionsAjustes['rowData'] = [];
        this.getField('tabla_promociones').initData(this.gridOptionsAjustes);//se carga de nuevo con valor null []
        this.successTablaItemFichas();   
        }
        this.getField('btnTerminarAjusteRec').setDisabled(false);
        this.getField('btnDevolver').setDisabled(false);
    }
    grabarTodo(){
        if(this.tamanoDatos === 0){
            this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
            this.getField('proceso_id').setValue(this.props.data.proceso_id);
            this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
            this.getField('actividad_id').setValue(this.props.data.actividad_id);
            this.getField('btnTerminarAjusteRec').setDisabled(true);

            let datos = {
                datos:{
                    id_formulario: this.formId,
                    produccion_fichas_id: this.getField('produccion_fichas_id').getValue(),
                    proceso_id: this.getField('proceso_id').getValue(),
                    actividad_configuracion_id: this.getField('actividad_configuracion_id').getValue(),
                    actividad_id:this.getField('actividad_id').getValue() 
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'terminar', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successClose,
                error: this.error_,
                showMessage :false,
                general: this.generalFormatPmv
            });


                /*this.generalFormat.nombre_accion = 'servicio_terminar_etapa_ajustes_recepcion';
                this.service.send(
                    {
                        endpoint:this.constant.formConfiguration(),
                        method:'POST',
                        body:body,
                        success: this.successCloseEstage, 
                        error:this.error_,
                        general: this.generalFormat,
                    });*/ 
        }else
            this.alertGeneral.toggle(true,'Faltan items por recibir',"error");
    }

    grabarItem(id,operario){
        if(operario !== null && operario !== ''){
            let datos = {
                datos:{
                    id_formulario: this.formId,
                    id: id,
                    actividad_id:this.props.data.actividad_id
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-alistamientoajustes', operacion: 'agregar', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successGrabarItem,
                error: this.error_,
                showMessage :false,
                general: this.generalFormatPmv
            });

            /*this.generalFormat.nombre_accion = 'servicio_marcar_agregado_ajustes_recepcion';
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'PUT',
                    body:body,
                    success: this.successGrabarItem, 
                    error:this.error_,
                    general: this.generalFormat,
                });*/ 
        }else
            this.alertGeneral.toggle(true,'Este item no tiene operario asignado',"error");
    }

    successGrabarItem(data){
        if(data.estado_p === 200){
            if(this.tamanoDatos > 1){
                this.recuperarOperarios();
            }else{
                this.getField('tablaAjusteRecepcion').toggle(false);
                this.tamanoDatos = 0;
            }
        }
    }

}

FormJaivana.addController('prod-recepcionajustes',CustomAjustesRecepcion);
export default CustomAjustesRecepcion;